import React, { useEffect, useContext } from "react";
import { Button } from "@material-ui/core";
import { useQuery } from "@apollo/client";

import logger from "../../utils/logger";
import { APP_INSIGHTS_EVENTS, EMPTY_GRAPHS_VALUES } from "../../constants";
import { GET_SENSORS_LIST } from "../../queries/stockpiles.gql";
import GraphsContainer from "../graphs-container/graphs-container.component";
import { MatchContext } from "../../context";
import { SET_DATA } from "../../reduce/actionTypes";
import useTrackEvent from "../../utils/hooks/use-track-app-event";
import ModalWindow from "../HOC/modal-window/modal-window.component";
import GraphExportModal from "../graph-export-modal/graph-export-modal.component";

const GraphsPage = (): JSX.Element => {
  const { state, dispatch } = useContext(MatchContext);
  const trackEvent = useTrackEvent();

  useQuery(GET_SENSORS_LIST, {
    onCompleted: (data) => {
      dispatch({
        type: SET_DATA,
        payload: { sensorsList: data.listOfDataSetpoints },
      });
    },
  });

  const handleSensorChange = (e) => {
    const name = e.target.name.toUpperCase();
    const value = e.target.value;
    trackEvent(APP_INSIGHTS_EVENTS.CHANGE_SETPOINT, {
      graph: name,
      tag: value,
      stockpiles: state.highlightedCols,
    });
    dispatch({
      type: SET_DATA,
      payload: { graphSensor: { ...state.graphSensor, [name]: value } },
    });
  };

  const handleClearGraphsClick = () => {
    logger.info("handle clear graphs");
    dispatch({
      type: SET_DATA,
      payload: { graphSensor: EMPTY_GRAPHS_VALUES },
    });
  };

  const handleExportGraphsClick = () => {
    logger.info("handle export graphs");
    dispatch({
      type: SET_DATA,
      payload: { showGraphExportModal: true },
    });
  };

  return (
    <div className="cards">
      <div className="custom-card card-common root">
        <ModalWindow show={state.showGraphExportModal}>
          <GraphExportModal
            highlightedCols={
              state.showGraphExportModal ? state.highlightedCols : []
            }
          />
        </ModalWindow>
        <div className="header-content">
          <div className="stick-right">
            <Button
              variant="outlined"
              color="primary"
              className="btn"
              onClick={handleExportGraphsClick}
              disabled={state.highlightedCols.length === 0 ? true : false}
            >
              Export Graphs
            </Button>
            <Button
              variant="outlined"
              color="primary"
              className="btn"
              onClick={handleClearGraphsClick}
              disabled={
                JSON.stringify(EMPTY_GRAPHS_VALUES) ===
                JSON.stringify(state.graphSensor)
              }
            >
              Clear Graphs
            </Button>
          </div>
        </div>
        <GraphsContainer handleSensorChange={handleSensorChange} />
      </div>
    </div>
  );
};

export default GraphsPage;
